export default "__VITE_ASSET__DKL5yDl$__"